import axiosInstance from '@/services/axiosInstance'

async function clickbannernoticias (params = null) {
  const req = {
    url: 'api/usuarios/clickbannernoticias',
    method: 'PUT',
    headers: {
      'Content-type': 'application/json',
      'access-control-allow-origin': '*'
    },
    params,
  }
  const res = await axiosInstance(req)
  return res.data
}

export { clickbannernoticias }
